var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"BusinessView"},[_c('MuiGridContainer',{staticClass:"TemplateDefault__container pt-6",attrs:{"fluid":false,"padding-bottom":false,"padding-top":false}},[_c('RouterView')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }